import { render, staticRenderFns } from "./MySortEdit.vue?vue&type=template&id=40c0ad96&"
import script from "./MySortEdit.vue?vue&type=script&lang=js&"
export * from "./MySortEdit.vue?vue&type=script&lang=js&"
import style0 from "./MySortEdit.vue?vue&type=style&index=0&id=40c0ad96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports